module.exports = __webpack_public_path__ + "static/media/innocent.3d65f745.png";